import ProdutoFab from './ClienteFab';

export default ProdutoFab;
